import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import DownloadLuckyDrawParticipants from '../../views/luckyDraw/download';

const LuckyDraws = () => {
  return (
    <PageTemplate>
      <DownloadLuckyDrawParticipants />
    </PageTemplate>
  );
};

export default LuckyDraws;
